import { ProviderType } from "@ternary/api-lib/analytics/enums";
import { Dimension } from "@ternary/api-lib/analytics/ui/types";

export function filterMultiCloudDimensions(dimensions: Dimension[]) {
  return dimensions.filter(
    (dimension) =>
      dimension.providerType === ProviderType.TERNARY ||
      dimension.providerType === ProviderType.FOCUS
  );
}
